import Vue from 'vue';

import Vuelidate from 'vuelidate'
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";

Vue.use(Vuelidate);
import customFormGroup from '@components/ui/validation.vue'
Vue.use(vuelidateErrorExtractor, {
	i18n: false,
	/**
	* Optionally provide the template in the configuration.
	* or register like so Vue.component("FormField", templates.singleErrorExtractor.foundation6)
	*/
	template: customFormGroup, // you can also pass your own custom template
	messages: {
		required: "The {attribute} field is required" , // error messages to use
		email: "The {attribute} must be a valid email address" ,
		min: "min value" ,
		validZipCode : 'Invalid zip code',
		validPhoneNumber : 'Invalid phone number',
		validSocialSecurityNo : 'Invalid social security number',
	},
	attributes: { // maps form keys to actual field names
		email: "Email",
		username: "Username",
		account_email: 'account email',
		customer_email: 'customer email',
		address_line_1: 'address',
		address_line_2: 'address line 2',
		zip_code: 'zip code',
		start_date_without_permit : 'start date without permit',
		start_date_with_permit : 'start date with permit',
		end_date : 'end date',
		first_name : 'first name',
		middle_initial : 'middle initial',
		last_name : 'last name',
		phone : '',
		secondary_phone : 'secondary phone',
		driver_license_no : 'driver license no ',
		driver_license_expiration_date : 'driver license expiration date',
		social_security_no : 'social security no',
		birth_date : 'birth date',
		us_citizen : 'us citizen',
		us_work_authorized : 'us work authorized',
		birth_country : 'birth country'
		
	}
});

Vue.component("validation", customFormGroup);
//Vue.component("form-group", templates.singleErrorExtractor.foundation6);